module.exports = __webpack_public_path__ + "img/portada_img_der1.79268264.png";